import type { FC } from '../../lib/teact/teact';
import React, { useCallback } from '../../lib/teact/teact';
import { getActions } from '../../global';

import type { ApiPeer, ApiUser } from '../../api/types';

import { isUserBot, isUserId } from '../../global/helpers';
import buildClassName from '../../util/buildClassName';
import { openPeerFromUserLink } from '../../util/openPeer';

import useLang from '../../hooks/useLang';

import Link from '../ui/Link';

type OwnProps = {
  className?: string;
  sender?: ApiPeer;
  shouldBlockUserProfile?: boolean;
  children: React.ReactNode;
};

const UserLink: FC<OwnProps> = ({
  className, sender, shouldBlockUserProfile, children,
}) => {
  const { showNotification } = getActions();
  const lang = useLang();

  const handleClick = useCallback(() => {
    if (sender) {
      if (shouldBlockUserProfile && isUserId(sender.id) && !isUserBot(sender as ApiUser)) {
        showNotification({ message: lang('HideInProtectedGroup') });
        return;
      }

      openPeerFromUserLink(sender);
    }
  }, [lang, sender, shouldBlockUserProfile, showNotification]);

  if (!sender) {
    return children;
  }

  return (
    <Link className={buildClassName('UserLink', className)} onClick={handleClick}>{children}</Link>
  );
};

export default UserLink;
